import axios from "axios";
import {baseURL} from "./api";

const marketplaceApi = axios.create({ baseURL });

/**
 * Resolve a Microsoft Marketplace purchase token.
 * Returns subscription details (planId, email, etc.)
 */
export const resolveMarketplaceToken = async (token) => {
  const response = await marketplaceApi.post('/public/marketplace/resolve', { token });
  return response.data;
};

/**
 * Activate a subscription and provision the Betterfly tenant.
 */
export const activateMarketplace = async (data) => {
  const response = await marketplaceApi.post('/public/marketplace/activate', data);
  return response.data;
};
